var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"full-video position-fixed d-flex align-items-center"},[_c('vimeo',{attrs:{"vimeo_key":"S00","autoplay":true},on:{"ended":_vm.goMap,"play":_vm.play}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }